import type { SVGProps } from "react";
import * as React from "react";

const SvgFolderPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2 19H1zM4 3V2zm5 0 .832-.555A1 1 0 0 0 9 2zm2 3-.832.555A1 1 0 0 0 11 7zm9 0V5zm-7 5a1 1 0 1 0-2 0zm-2 6a1 1 0 1 0 2 0zm-2-4a1 1 0 1 0 0 2zm6 2a1 1 0 1 0 0-2zm6 4a1 1 0 0 1-.293.707l1.414 1.414A3 3 0 0 0 23 19zm-.293.707A1 1 0 0 1 20 20v2a3 3 0 0 0 2.121-.879zM20 20H4v2h16zM4 20a1 1 0 0 1-.707-.293l-1.414 1.414A3 3 0 0 0 4 22zm-.707-.293A1 1 0 0 1 3 19H1a3 3 0 0 0 .879 2.121zM3 19V5H1v14zM3 5a1 1 0 0 1 .293-.707L1.879 2.879A3 3 0 0 0 1 5zm.293-.707A1 1 0 0 1 4 4V2a3 3 0 0 0-2.121.879zM4 4h5V2H4zm4.168-.445 2 3 1.664-1.11-2-3zM11 7h9V5h-9zm9 0a1 1 0 0 1 .707.293l1.414-1.414A3 3 0 0 0 20 5zm.707.293A1 1 0 0 1 21 8h2a3 3 0 0 0-.879-2.121zM21 8v11h2V8zm-10 3v6h2v-6zm-2 4h6v-2H9z"
    />
  </svg>
);
export default SvgFolderPlus;
